import Http from './http'
export const getPersonalTasks = params => Http.get('/admin/personal-tasks', { params })
export const getPersonalTaskSummary = () => Http.get('/admin/personal-tasks/summary')
export const getPersonalTaskProjects = () => Http.get('/admin/personal-tasks/platforms')
export const getPersonalTaskUsers = () => Http.get('/admin/personal-tasks/users')
export const createPersonalTask = data => Http.post('/admin/personal-tasks', data)
export const uploadPersonalTaskAttachment = (id, file) => { const body = new FormData(); body.append('file', file); return Http.post(`/admin/personal-tasks/${id}/attachments`, body, { headers: { 'Content-Type': 'multipart/form-data' } }) }
export const updatePersonalTask = (id, data) => Http.patch(`/admin/personal-tasks/${id}`, data)
export const deletePersonalTask = id => Http.delete(`/admin/personal-tasks/${id}`)
